const TitleH3 = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => {
  return (
    <h3
      className={`text-primary text-2xl sm:text-3xl lg:text-4xl ${className}`}
    >
      {title}
    </h3>
  );
};

export default TitleH3;
